import { Card, CardContent, CardHeader, CardTitle } from "./ui/Card";
import { UserPlus, DollarSign, Package, XCircle } from "lucide-react";

interface StatsCardsProps {
  data: {
    sales: { value: number; last_month: number; diff: number };
    customers: { value: number; last_month: number; diff: number };
    cancelled: { value: number; last_month: number; diff: number };
    total_orders: { value: number; last_month: number; diff: number };
  } | null;
}

export function StatsCards({ data }: StatsCardsProps) {
  if (!data) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-32 bg-gray-200 rounded animate-pulse" />
        ))}
      </div>
    );
  }

  const stats = [
    {
      title: "Novos Clientes",
      value: data.customers.value.toString(),
      icon: UserPlus,
      change: `${data.customers.diff > 0 ? "+" : ""}${data.customers.diff}%`,
      changeType: data.customers.diff >= 0 ? "positive" : "negative" as const,
    },
    {
      title: "Total Vendas",
      value: `R$ ${data.sales.value.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
      })}`,
      icon: DollarSign,
      change: `${data.sales.diff > 0 ? "+" : ""}${data.sales.diff}%`,
      changeType: data.sales.diff >= 0 ? "positive" : "negative" as const,
    },
    {
      title: "Total de Pedidos",
      value: data.total_orders.value.toString(),
      icon: Package,
      change: `${data.total_orders.diff > 0 ? "+" : ""}${data.total_orders.diff}%`,
      changeType: data.total_orders.diff >= 0 ? "positive" : "negative" as const,
    },
    {
      title: "Cancelados",
      value: data.cancelled.value.toString(),
      icon: XCircle,
      change: `${data.cancelled.diff > 0 ? "+" : ""}${data.cancelled.diff}%`,
      changeType: data.cancelled.diff <= 0 ? "positive" : "negative" as const, // Menos cancelados é positivo
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card
            key={stat.title}
            className="border border-gray-200 hover:shadow-md transition-shadow duration-200"
          >
            <CardHeader className="pb-3">
              <div className="flex items-center justify-between">
                <CardTitle className="text-sm font-medium text-[#68686A]">
                  {stat.title}
                </CardTitle>
                <Icon className="h-4 w-4 text-[#68686A]" />
              </div>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-semibold text-gray-900 mb-1">
                {stat.value}
              </div>
              <p
                className={`text-sm ${stat.changeType === "positive"
                  ? "text-[#849D70]"
                  : "text-[#C2452D]"
                  } font-medium`}
              >
                {stat.change} em relação ao período anterior
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}